import {
  newTracker,
  setUserId,
  trackPageView as snowplowTrackPageView,
} from "@snowplow/browser-tracker";
import { env } from "@env/unsafe-public";

const SNOWPLOW_TRACKER_NAME = "js-tracker";
const SNOWPLOW_APP_ID = "admin";

let isInitialized = false;

function resolveSnowplowEndpoint(hostname: string): string | null {
  const normalizedHostname = hostname.toLowerCase();

  if (
    normalizedHostname === "localhost" ||
    normalizedHostname === "127.0.0.1" ||
    normalizedHostname.endsWith(".localhost") ||
    normalizedHostname.includes("ngrok")
  ) {
    return null;
  }

  return env.DEV_ENV ? "sp-dev.jeff-app.com" : "sp.jeff-app.com";
}

export function initSnowplow({ userEmail }: { userEmail: string }): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const endpoint = resolveSnowplowEndpoint(window.location.hostname);

  if (!endpoint) {
    return false;
  }

  if (!isInitialized) {
    newTracker(SNOWPLOW_TRACKER_NAME, endpoint, {
      appId: SNOWPLOW_APP_ID,
    });
    isInitialized = true;
  }

  setUserId(userEmail);

  return true;
}

export function trackPageView(): void {
  if (!isInitialized) {
    return;
  }

  snowplowTrackPageView();
}
